// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xjwq","right":"styles_right__3hj7T"};